import { generateGeneralSelector } from "./utils";

const tlsCertificate =
  generateGeneralSelector<"tlsCertificate">("tlsCertificate");

export default tlsCertificate;
